import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'

import { checkCookie, setCookie } from '../../utils'
import { BASE_URL, DEFAULT_PARAM } from '../../Contansts'

import styles from './CookiePopup.module.scss'

function CookiePopup() {
  const [showPopup, setShowPopup] = useState(false)
  const [data, setData] = useState(null)
  let timer

  useEffect(() => {
    const cookieExists = checkCookie('nipl')

    if (!cookieExists) {
      const url = `${BASE_URL}/${'cookiespopups'}?${DEFAULT_PARAM}&locale=en`
      axios
        .get(url, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          setData(
            res?.data?.data && res?.data?.data.length > 0
              ? res?.data?.data[0]
              : null
          )
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          setCookie('nipl', 'NIPL', 365 * 2)
          setShowPopup(true)
          // eslint-disable-next-line react-hooks/exhaustive-deps
          timer = setTimeout(() => {
            setShowPopup(false)
          }, 10000)
        })
    }

    return () => clearTimeout(timer)
  }, []) // Empty dependency array ensures this runs once when the component mounts

  const handleClose = () => {
    setShowPopup(false)
    clearTimeout(timer)
  }

  return showPopup && data ? (
    <div className={styles.container}>
      <div className={styles.cookiePopup}>
        <div className={styles.detailsContainer}>
          <h3>{data?.title}</h3>
          <span>
            {data?.description}
            {data?.link?.path && (
              <>
                {`  [`}
                <Link to={data?.link?.path}>{data?.link?.label}</Link>
                {`]`}
              </>
            )}
          </span>
        </div>
        <button
          aria-label="Close"
          onClick={handleClose}
          className={styles.closeBtn}
        >
          ×
        </button>
      </div>
    </div>
  ) : null
}

export default CookiePopup
